var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLetter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E9E9EA",
  d: "M10.333.333H3.667c-2 0-3.334 1-3.334 3.334v4.666c0 2.334 1.334 3.334 3.334 3.334h6.666c2 0 3.334-1 3.334-3.334V3.667c0-2.334-1.334-3.334-3.334-3.334m.314 4.06L8.56 6.06c-.44.353-1 .527-1.56.527s-1.127-.174-1.56-.527L3.353 4.393a.513.513 0 0 1-.08-.706.5.5 0 0 1 .7-.08L6.06 5.273c.507.407 1.367.407 1.873 0l2.087-1.666a.49.49 0 0 1 .7.08.506.506 0 0 1-.073.706"
})));
export { SvgLetter as ReactComponent };